<template>
      <div class="">

      <v-data-table
          :headers="headers"
          :items="items"
          dense
          :hide-default-footer="true"
          :disable-pagination="true"
          no-data-text="No Coverages"
          :show-expand="true"
          :item-class="row_classes"
          :fixed-header="true"
          class="pc-table"
          width="100%"
          height="480"
          :key="`pc_list_${refresh}`"
          :search="PCSearch"
      >

            <template v-slot:top>
              <v-text-field
                class="pa-0 ma-0 ml-n2 "
                flat
                dense
                solo
                hide-details
                v-model="PCSearch"
                label="Filter"
                background-color="ycmd-very-lightest-gray"
              ></v-text-field>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td
                  :colspan="headers.length"
                  classxxx="pa-0 ma-0 fs-10 pl-5 font-weight-light "    
              >
                  <div v-if="item.rules && item.rules.length"
                      v-html="rulesHtml(item.rules)"
                  />
                  <div
                    v-else
                  >No rules
                  </div>
              </td>
            
            </template>          

          
          <template v-slot:item.actionsxxx="{item}">

            <v-tooltip 
                        bottom
                        nudge-bottom="5"
                        color="ycmd-black"
                        content-class="fade-0">
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="ycmd-blue"
                  class="pointer"
                  :size="22"

                >
                  edit
                </v-icon>
              </template>
              <span>Edit</span>
            </v-tooltip>

          </template>                       

      </v-data-table>
      </div>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {formatSimple} from '@/methods/formatters';

import { parseJSON } from 'date-fns';
  export default {
    props: {
      personalCoverages: {
          type: Array,
          default: () => []
      },
      filters: {
          type: Array,
          default: () => []
      },   
      refresh: {
        default: '',
        type: String
      },                     
              
    },
    components: {

    },    
    data: () => ({
      PCSearch: null
    }),
    mounted() {
    },
    methods: {
      ...mapGetters('schedule',['getFacilityById']),

      rulesHtml (rules) {

          if (rules && rules.length) {
              let options = ''
              rules.map(r => {
                  options += `<li>${r}</li>`
              })
              let html = `<h5>Rules</h5><ul>${options}</ul>`
              return html
          }

          return null
      },   
      
      formatDate(dt) {

          let formatted = formatSimple(dt,'MM/dd/yyyy hh:mm a')
          
          return formatted
      },
      buildDate(pc, prefix) {

        let year = pc[`${prefix}_year`]
        let month = pc[`${prefix}_month`]
        let day = pc[`${prefix}_day`]

        let hour = pc[`${prefix}_hours`]
        let minute = pc[`${prefix}_minutes`]
        let second = pc[`${prefix}_second`]

        let newdt = new Date()
        newdt.setHours(hour)
        newdt.setMinutes(minute)

        let formattedTime = formatSimple(newdt,'hh:mm a')
        return `${month}/${day}/${year} ${formattedTime}`
      },      
      rowClick(item) {

        this.$emit('select', item)
      },
      translatePC(PC) {
        console.log('PC', PC)

        let s = JSON.parse(JSON.stringify(PC))
        s.startFormatted = this.buildDate(s, 'start')
        s.endFormatted = this.buildDate(s,'end')
        if (s.filter) {
          let f = this.filterMap[s.filter]
          s.filterName = f ? f.name : s.filter
        }
        return s
      },
      twoDigit (num) {
        let str = num + ''
        if (str.length === 1) {
            str = '0' + str
        }
        return str
      },

      row_classes(item) {
        let classes = ['pa-0', 'ma-0', 'pointer']

        if (item.odd) {
          classes.push('odd')
        }

        return classes
      },      
    },
    computed: {
      filterMap(){
        let map={}
        this.filters.map(f => {
          map[f.id] = f
        })

        return map
      },
      items () {
        let arr = []
        let i=0
        this.personalCoverages.map(s => {
          if (s.personal) {
            let translated = this.translatePC(s)
            translated.odd = i++ % 2
            
            arr.push(translated)
          }
        })

        let sorted = arr.sort( (a,b) => {
            return a.name.localeCompare(b.name)
        })

        return sorted
      },
      headers () {
        let headers = [    
            {
                text: 'Name',
                value: 'name',
                width: '40%',
                sortable: true,
                cellClass:"pa-0 ma-0 pt-1",
                
            },
            {
                text: 'Filter',
                value: 'filterName',
                width: '30%',
                sortable: true,
                cellClass:"pa-0 ma-0 pt-1",
            },
            {
                text: 'Starts',
                value: 'startFormatted',
                width: '15%',
                sortable: true,
                cellClass:"pa-0 ma-0 pt-1",
            },
            {
                text: 'Ends',
                value: 'endFormatted',
                width: '15%',
                sortable: true,
                cellClass:"pa-0 ma-0 pt-1",
            },

            { text: '', 
                value: 'data-table-expand',
                cellClass:"fs-12 filterTableExpand"
            },                                                                                  
        ]

        return headers
      },  
      actionList () {
        return []
      },

    },
    watch: {

    }
  }
</script>

